

const SUPERSET_URL_DEV = "https://superset-gridsolutions-dev.eastus.cloudapp.azure.com/";
const SUPERSET_URL_QA = "https://superset-gridsolutions-qa.eastus.cloudapp.azure.com/";
const SUPERSET_URL_PROD = "https://superset-gridsolutions-prod.eastus.cloudapp.azure.com/";

const isProd = window?.location?.hostname === 'gridsolutions.eaton.com';
const isQA = window?.location?.hostname === 'smpservices-qa.eastus.cloudapp.azure.com';

const supersetConfig = {
    superset_url: isProd ? SUPERSET_URL_PROD : isQA ? SUPERSET_URL_QA : SUPERSET_URL_DEV
};

export default supersetConfig;
    
